<!-- Centered branding, welcome message and animated diagram -->
<div class="flex flex-1 min-h-0 flex-col items-center justify-center gap-16 px-6">
  <!-- Medinbox AI branding (logo + AI icon + product name) -->
  <div class="flex items-center gap-4">
    <mai-mib-logo size="large"></mai-mib-logo>
  </div>

  <!-- Welcome message, announced to assistive technologies -->
  <h1
    class="text-center text-[33px] font-normal leading-tight text-[#102753]"
    role="status"
    aria-live="polite"
  >
    Welcome.<br />The session<br />is about to begin.
  </h1>

  <!-- Decorative animated illustration (self-drawing SVG) -->
  <img
    class="block w-full max-w-[617px] aspect-[617/404]"
    src="./svg/medinbox-diagram-animated.svg"
    alt=""
    aria-hidden="true"
  />
</div>

<!-- Footer -->
<footer class="flex w-full items-center justify-center py-8">
  <mai-copyright-and-legal-link
    class="text-center font-light text-gray-500"
  ></mai-copyright-and-legal-link>
</footer>
